import { useMemo } from "react";
import { useRole } from "@/store/role";
import {
  hasAllPermissions,
  hasAnyPermission,
  hasPermission,
} from "@/lib/permissions";

export function usePermissions() {
  const { permissions } = useRole();

  return useMemo(
    () => ({
      permissions,
      can: (key) => hasPermission(permissions, key),
      canAny: (keys) => hasAnyPermission(permissions, keys),
      canAll: (keys) => hasAllPermissions(permissions, keys),
    }),
    [permissions],
  );
}
